<template>
  <div class="resources-group">
    <div class="resources-group__title" @click="show = !show">
      <span class="ms-main-head">
        <icon :type="show ? 'ios-arrow-down' : 'ios-arrow-forward'" />
        {{ title }}
      </span>
      <tag class="resources-group__info ms-help">
        {{ resources.length }}
      </tag>
    </div>
    <div class="resources-group__content" v-show="show">
      <resources-categories :resources="resources" />
    </div>
  </div>
</template>

<script>
import ResourcesCategories from './resources-categories'

export default {
  props: {
    resources: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      show: this.title === 'Основной договор'
    }
  },
  components: {
    ResourcesCategories
  }
}
</script>

<style lang="less">
.resources-group {
  &:not(:first-child) {
    margin-top: 24px;
  }

  &__title {
    display: flex;
    align-items: center;
    padding: 8px;
    padding-left: 12px;
    letter-spacing: 1px;
    background: rgba(@dt-dark-card, 0.9);
    border: 1px solid @dt-dark-primary;
    border-radius: 4px;
    cursor: pointer;

    i {
      font-size: 20px;
    }
  }

  &__info {
    margin-left: auto;
    font-weight: bold;
  }

  &__content {
    padding-left: 40px;
    margin-top: 12px;
  }
}

.light {
  .resources-group__title {
    background: #ffffff;
    border: 1px solid #e8eaec;
  }
}
</style>
